import { render, staticRenderFns } from "./base.vue?vue&type=template&id=6f5ce6ac&scoped=true&"
var script = {}
import style0 from "./base.vue?vue&type=style&index=0&id=6f5ce6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ce6ac",
  null
  
)

export default component.exports